module.exports = __webpack_public_path__ + "static/media/ico_facilidade_new.a1d2a7d2.svg";